import styled from "@emotion/styled";
import { IconButton } from "@snapchat/snap-design-system";

export const EditIconButton = styled(IconButton)<{ show: boolean }>`
    cursor: pointer;
    display: ${({ show }) => (show ? "block" : "none !important")};
    padding: 8px !important;
    ${({ isDisabled }) => (isDisabled ? `pointer-events: none;` : null)}

    i {
        font-size: 16px !important;
    }
`;
